import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/lib/utils2";

const ACTION_COLORS = {
  create: "bg-brand-forest text-white",
  update: "bg-brand-sand/30 text-brand-terracotta",
  delete: "bg-brand-terracotta/10 text-brand-terracotta border-brand-terracotta",
  bulk_import: "bg-brand-forest text-white",
};

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { (async () => setRows((await api.get("/audit-log")).data))(); }, []);

  return (
    <div className="p-6 md:p-10 lg:p-12 max-w-[1200px] mx-auto" data-testid="audit-log-page">
      <PageHeader title="Audit Log" subtitle="Tax-audit defence — every mutation logged with timestamp, user, action and entity." />
      <Card className="rounded-sm border-brand-line shadow-none overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-secondary/60 text-[10px] uppercase tracking-[0.15em] text-brand-muted">
            <tr>
              <th className="text-left px-5 py-3">When</th>
              <th className="text-left px-3 py-3">User</th>
              <th className="text-left px-3 py-3">Action</th>
              <th className="text-left px-3 py-3">Entity</th>
              <th className="text-left px-3 py-3">Entity ID</th>
              <th className="text-left px-3 py-3">Details</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-brand-muted text-sm">No audit entries yet.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-brand-line">
                <td className="px-5 py-2.5 whitespace-nowrap text-xs">{new Date(r.at).toLocaleString("en-IN")}</td>
                <td className="px-3 py-2.5">{r.user_email}</td>
                <td className="px-3 py-2.5">
                  <Badge className={`rounded-sm uppercase text-[10px] tracking-[0.1em] ${ACTION_COLORS[r.action] || ""}`}>{r.action}</Badge>
                </td>
                <td className="px-3 py-2.5 capitalize">{r.entity}</td>
                <td className="px-3 py-2.5 font-mono text-[10px]">{r.entity_id?.slice(0, 8) || "—"}</td>
                <td className="px-3 py-2.5 font-mono text-[10px] text-brand-muted">{JSON.stringify(r.details || {})}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
